import {
  Button,
  Card,
  Col,
  DatePicker,
  List,
  message,
  Modal,
  Pagination,
  Row,
  Select,
  Space,
  Spin,
} from "antd";
import { Option } from "antd/lib/mentions";
import Typography, { Title, Text } from "antd/lib/typography";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Get from "../services/Get";
import { CheckCircleOutlined } from "@ant-design/icons";

const WithdrawalHistory = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ page: 1, from: null, to: null });
  const [pagination, setPagination] = useState({ total: 0, current: 1 });

  const { RangePicker } = DatePicker;

  const getData = async () => {
    setLoading(true);
    try {
      const res = await Get.MLMWithdrawalHistory(filters);
      if (res.error) {
        message.error(res.error);
      } else {
        setHistory(res.data.data);
        setPagination({
          total: res.data.total,
          current: res.data.current_page,
        });
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  useEffect(() => {
    getData();
  }, [filters]);

  const handleDateChange = (dates) => {
    if (dates) {
      setFilters({
        ...filters,
        page: 1,
        from: dates[0].format("YYYY-MM-DD"),
        to: dates[1].format("YYYY-MM-DD"),
      });
    } else {
      setFilters({ ...filters, page: 1, from: null, to: null });
    }
  };

  return (
    <div className="layout-content">
      <Row gutter={[24, 24]} justify="center">
        <Col xs={24} md={12}>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh",
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Space
              direction="vertical"
              size="middle"
              style={{ display: "flex", marginBottom: 20 }}
            >
              {/* Incomes List */}
              <Card>
                <Row>
                  <RangePicker
                    onChange={handleDateChange}
                    style={{ marginBottom: 16 }}
                  />
                </Row>
                <List
                  header={
                    <Typography.Title level={4}>
                      Withdrawal History
                    </Typography.Title>
                  }
                  bordered
                  loading={loading}
                  dataSource={history}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={
                          <CheckCircleOutlined style={{ color: "#4CAF50" }} />
                        }
                        title={<>{item.title}</>}
                        description={
                          <>
                            <Typography.Text>
                              {item.description}
                            </Typography.Text>
                            <br />
                            Amount:{" "}
                            <Typography.Text>₹{item.price}</Typography.Text>
                            <br />
                            Date:{" "}
                            <Typography.Text>
                              {formatDate(item.created_at)}
                            </Typography.Text>
                          </>
                        }
                      />
                    </List.Item>
                  )}
                />
                <Pagination
                  current={pagination.current}
                  total={pagination.total}
                  pageSize={10}
                  onChange={(page) => setFilters({ ...filters, page })}
                  style={{ marginTop: 16, textAlign: "right" }}
                />
                {/* <List
                  header={
                    <Typography.Title level={4}>
                      Withdrawal History
                    </Typography.Title>
                  }
                  bordered
                  loading={loading}
                  dataSource={history}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={
                          <CheckCircleOutlined style={{ color: "#4CAF50" }} />
                        }
                        title={<>{item.title}</>}
                        description={
                          <>
                            <Typography.Text>
                              {item.description}
                            </Typography.Text>
                            <br />
                            Amount:{" "}
                            <Typography.Text>₹{item.price}</Typography.Text>
                            <br />
                            Date:{" "}
                            <Typography.Text>
                              {formatDate(item.created_at)}
                            </Typography.Text>
                          </>
                        }
                      />
                    </List.Item>
                  )}
                /> */}
              </Card>
            </Space>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default WithdrawalHistory;
